import { API_BASE_URL } from '../config/api';

/**
 * Fire-and-forget safe voice telemetry (capture lifecycle).
 * Never sends audio, transcripts, or tokens.
 */
export function reportVoiceTelemetry(
  event: string,
  fields: Record<string, string | number | boolean | null | undefined> = {}
): void {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    if (!token) return;

    const safe: Record<string, string | number | boolean | null> = { event };
    for (const [key, value] of Object.entries(fields)) {
      if (value === undefined) continue;
      if (['voice_text', 'transcript', 'text', 'audio', 'token'].includes(key)) continue;
      safe[key] = value;
    }

    void fetch(`${API_BASE_URL}/voice/telemetry`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(safe),
      keepalive: true,
    }).catch(() => {
      /* never block capture on telemetry */
    });
  } catch {
    /* ignore */
  }
}
